/**
 * Utilidades y constantes para el formulario de datos escolares.
 */

export const disableFutureDates = (date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return date < today;
};

export const NON_OPTION_CENTRO = {
  Id: '-1',
  Nombre: '',
  Domicilio: '',
  Poblacion: '',
  Provincia: '',
  Distrito: '',
  Telefono1: '',
  Telefono2: '',
  Fax: '',
  Email: '',
  Director: '',
  CCC: '',
  sufijo: '',
  numfactura: '',
  archivos: '',
  tipo: '',
};
